import React from 'react';
import Radio from 'components/forms/Radio';
import Error from 'components/forms/Error';

export default props => (
  <React.Fragment>
    <Radio
      {...props.input}
      {...props}
    />
    {props.meta.touched &&
      ((props.meta.error && <Error error={props.meta.error} />))}
  </React.Fragment>
);

